import config from "../config";

interface Quote {
  images: string[];
  content: string;
}

export const fetchMotivationalQuote = async (): Promise<Quote> => {
  const response = await fetch(`${config.apiUrl}/quote`);

  if (!response.ok) {
    throw new Error("Network response was not ok");
  }
  const data = await response.json();
  return data;
};
